import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { Link } from 'react-router-dom';
import userIcon from '../img/User-Icon.png';
import TopBarIcons from './TopBarIcons';
import { Bar } from "react-chartjs-2";
import axios from "axios";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import IconsDisplay from './IconsDisplay';
import Sidebar from './Sidebar';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Dashboard = () => {
  const [totalRequisitions, setTotalRequisitions] = useState(0);
  const [totalSurrenders, setTotalSurrenders] = useState(0);
  const [chartData, setChartData] = useState(null);
  const theUserType = localStorage.getItem('userType');


  useEffect(() => {
    const fetchData = async () => {
      try {
        const requisitionsResponse = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/requisitions/count`
        );
        const surrendersResponse = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/surrenders/count`
        );
        const submissionsResponse = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/dashboard/submissions`
        );

        setTotalRequisitions(requisitionsResponse.data.total);
        setTotalSurrenders(surrendersResponse.data.total);

        const graphData = submissionsResponse.data;
        setChartData({
          labels: graphData.map((item) => item.date),
          datasets: [
            {
              label: "Requisitions",
              data: graphData.map((item) => item.requisitions),
              backgroundColor: "rgba(54, 162, 235, 0.6)",
            },
            {
              label: "Surrenders",
              data: graphData.map((item) => item.surrenders),
              backgroundColor: "rgba(255, 99, 132, 0.6)",
            },
          ],
        });
      } catch (error) {
        console.error("Error fetching dashboard data", error);
      }
    };

    fetchData();
  }, []);
    

    return (
        <div id="wrapper">
           {/* Sidebar */}
           <Sidebar userType={theUserType} />


{/* Content Wrapper */}

<div id="content-wrapper" className="d-flex flex-column">

    {/* Main Content */}
    <div id="content">

        {/* Topbar */}
        <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

            {/* Sidebar Toggle */}
            <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                <i className="fa fa-bars"></i>
            </button>

            {/* Topbar Search */}
            <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
                <div className="input-group">
                    <input type="text" className="form-control bg-light border-0 small" placeholder="Search"
                        aria-label="Search" aria-describedby="basic-addon2" />
                    <div className="input-group-append">
                        <button className="btn btn-primary" type="button">
                            <i className="fas fa-search fa-sm"></i>
                        </button>
                    </div>
                </div>
            </form>

            {/* Topbar Navbar */}
            <ul className="navbar-nav ml-auto">

                <TopBarIcons />
                
                 

            </ul>

        </nav>
        {/* End of Topbar */}

        {/* Begin Page Content */}
        <div className="container-fluid">

            <h1 className="h3 mb-4 text-gray-800">Dashboard</h1>
            <div id="new-requisition"> 
                <Link to="/reqform" className="btn btn-primary" id="new-requisition-button">
                    <i id="plus-icon" className="fas fa-plus-circle"></i>
                    <span>New Requisition</span>
                </Link>
            </div>  
            <IconsDisplay/>
            

        </div>
        {/* End of container-fluid */}

    </div>
    {/* End of Main Content */}

    {/* Footer */}
    <footer className="sticky-footer bg-white">
        <div className="container my-auto">
            <div className="copyright text-center my-auto">
                <span>Copyright &copy; Farm Concern International 2025</span>
            </div>
        </div>
    </footer>
    {/* End of Footer */}

</div>


    
    {/* End of Content Wrapper */}


           
          
          
        </div>
      );  
};

export default Dashboard;